<mat-expansion-panel #matExpansionPanel>
  <mat-expansion-panel-header>
    <mat-panel-title>
      @if (hasNeedsReview) {
        <fa-icon [icon]="['far', 'exclamation-triangle']" class="red size-18"></fa-icon>
      }
      Site Notes
    </mat-panel-title>
  </mat-expansion-panel-header>
  <mat-divider></mat-divider>

  <ng-container>
    <div class="new-button">
      <button (click)="addUpdateNote()" color="primary" data-cy="add-site-note" mat-raised-button type="button">
        Add New
      </button>
    </div>
  </ng-container>
  <div class="note-list">
    <table [dataSource]="dataSource" aria-describedby="Site Notes" class="site-notes-list-table" mat-table matSort>
      <ng-container matColumnDef="id">
        <th *matHeaderCellDef class="medium-column" data-cy="date-sort" mat-header-cell mat-sort-header scope="col">
          Date Created
        </th>
        <td *matCellDef="let element" class="medium-column" mat-cell>
          <div class="note-created-info">
            <div class="needs-review-div">
              @if (element.needsReview) {
                <fa-icon [icon]="['far', 'exclamation-triangle']" class="red size-18 needs-review-icon"></fa-icon>
              }
            </div>
            <div class="note-info-text">
              <div>{{ element.createDate | date: 'shortDate' }}</div>
              <div class="created-name">
                {{ element.user?.getDisplayName({ includeEmail: false }) }}
              </div>
            </div>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="category">
        <th *matHeaderCellDef class="small-column" mat-header-cell mat-sort-header scope="col">
          <div class="category-filter">
            <div>Category</div>
            <mat-form-field data-cy="category-filter">
              <mat-select (selectionChange)="applyFilter($event.value)" placeholder="Filter">
                <mat-option value="">All</mat-option>
                <mat-option *ngFor="let category of categories" [value]="category">
                  {{ category }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </th>
        <td *matCellDef="let element" class="small-column" mat-cell>
          {{ element.category }}
        </td>
      </ng-container>
      <ng-container matColumnDef="note">
        <th *matHeaderCellDef class="large-column" mat-header-cell scope="col">Details</th>
        <td *matCellDef="let element" class="large-column" data-cy="note-text" mat-cell>
          {{ element.note }}
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef class="small-column" mat-header-cell scope="col">Actions</th>
        <td *matCellDef="let element" class="small-column" mat-cell>
          <div class="action-icons">
            @if (currentUser?.isAdmin || element.needsReview || currentUser?.id === element.userId) {
              <div (click)="addUpdateNote(element)" class="edit-icon">
                <fa-icon [icon]="['far', 'edit']" class="blue size-18"></fa-icon>
              </div>
            }
            @if (currentUser?.isAdmin) {
              <div (click)="updateVisibility(element)" class="change-visibility">
                <fa-icon
                  [icon]="['far', element.hideFromLimitedAdmins ? 'eye-slash' : 'eye']"
                  [matTooltip]="'Click to ' + (element.hideFromLimitedAdmins ? 'un' : '') + 'hide from Limited Admins.'"
                  class="blue size-18"></fa-icon>
              </div>
            }
            @if (currentUser?.isAdmin || currentUser?.id === element.user?.id) {
              <div (click)="deleteNote(element.id)" class="delete-icon">
                <fa-icon [icon]="['far', 'trash']" class="gray size-18"></fa-icon>
              </div>
            }
          </div>
        </td>
      </ng-container>
      <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
      <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
    </table>
  </div>
</mat-expansion-panel>
